import 'material-design-icons/iconfont/material-icons.css';
//import 'font-awesome/css/font-awesome.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles/theme/animate.css';
import './assets/styles/theme/style.css';
import './assets/styles/theme/style-responsive.css';
import './assets/styles/theme/color/default.css';
import './assets/styles/app.css';
import './assets/styles/theme/appRefactor.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'rc-time-picker/assets/index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
// import {createBrowserHistory} from 'history';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import setAuthorizationToken from './shared/setAuthorizationToken';
import {actionCreators} from './store/UserAuthentication';
import jwt_decode from 'jwt-decode';
import intercept from "./shared/axios";
import './components/common/AxisFontsLibrary';
import configureStore, { history } from './store/configureStore';


// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);
intercept(store,actionCreators.logoutUser);
const rootElement = document.getElementById('root');
if (localStorage.jwtToken) {
    setAuthorizationToken(localStorage.jwtToken);
    let user = jwt_decode(localStorage.jwtToken);
    store.dispatch(actionCreators.setUser(user));
}
ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App/>
        </ConnectedRouter>
    </Provider>,
    rootElement);

registerServiceWorker();
